module.exports = __webpack_public_path__ + "img/pethouse24.0ea25a95.jpg";